import formatPhone from 'src/functions/formatPhone'
import {
  BUTTON_CLOSE_POPUP_CLASS,
  BUTTON_DEPARTURE_ADDRESS_CLASS,
} from 'www/vue_components/common/PopupMap/constants'

function getPlacemarkBalloonTemplate(opts) {
  const {
    name,
    phone,
    address,
    lpuHref,
  } = opts

  const phoneTemplate = phone?.trim()
    ? `
            <div class="mt-4 d-flex">
                <span class="mr-6 text-info--text ui-icon-phone-call"></span>
                <div
                    class="text-body-1"
                    data-qa="popup_map_phone_lpu_text"
                >
                    ${formatPhone({ phone, country: { iso: window.COUNTRY_DATA.iso } })}
                </div>
            </div>
        `
    : ''

  const nameTemplate = lpuHref
    ? `
        <a
            class="text-h6 primary--text text-decoration-none"
            data-qa="popup_map_lpu_name_text"
            href="${lpuHref}"
        >
            ${name}
        </a>
      `
    : `
      <div
          class="text-h6 primary--text"
          data-qa="popup_map_lpu_name_text"
      >
          ${name}
      </div>
    `

  return `
        <div class="pa-6">
            ${nameTemplate}
            <div class="mt-4 d-flex">
                <span class="mr-6 text-info--text ui-icon-map-pin"></span>
                <div
                    class="text-body-1"
                    data-qa="popup_map_adderess_lpu_text"
                >
                    ${address}
                </div>
            </div>
            ${phoneTemplate}
            <button
                type="button"
                class="b-button b-button_light branding-btn branding-btn--background w-100 mt-4 ${BUTTON_DEPARTURE_ADDRESS_CLASS}"
                data-qa="popup_map_plot_route_button"
            >
                <span class="text-button">Проложить маршрут</span>
            </button>
            <button
                type="button"
                class="b-button b-button_text w-100 mt-2 ${BUTTON_CLOSE_POPUP_CLASS}"
                data-qa="popup_map_close_button"
            >
                <span class="text--text ui-icon-close-not-a-circle mr-2"></span>
                <span class="text-button text--text">Закрыть</span>
            </button>
        </div>
    `
}

export default getPlacemarkBalloonTemplate
